import * as React from 'react'

function SvgIconBlockchain(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 32 32" width="1em" height="1em" {...props}>
      <g id="blockchain" aria-labelledby="t-blockchain d-blockchain">
        <title id="t-blockchain">{'Blockchain'}</title>
        <desc id="d-blockchain">{'Three blocks chained'}</desc>
        <path d="M31.501 11.634l-6.062-3.5a.998.998 0 00-1 0l-6.062 3.5a.997.997 0 00-.5.866v3c0 .276.227.5.5.5s.5-.224.5-.5v-2.423l5.562 3.211v6.422l-2.104-1.215-1.005.571 3.107 1.798c.312.18.688.18 1 0l6.062-3.498a1 1 0 00.5-.867v-7a.991.991 0 00-.498-.865zm-12.125.577l5.562-3.21 5.604 3.229-5.562 3.211-5.604-3.23zm6.062 10.5v-6.382L31 13.118V19.5l-5.562 3.211z" />
        <path d="M18.604 10.504l1.006-.574-3.104-1.796a.998.998 0 00-1 0l-6.062 3.5a1 1 0 00-.5.866v3a.5.5 0 001 0v-2.423l5.56 3.213v6.421L13.4 21.496l-1.005.574 3.109 1.795c.311.18.691.18 1 0l6.062-3.498c.312-.18.5-.51.5-.867v-3c0-.275-.229-.5-.5-.5-.273 0-.5.224-.5.5v3L16.5 22.711V16a.5.5 0 00-.25-.433l-5.812-3.356L16 9.001l2.604 1.503z" />
        <path d="M13.625 16a.5.5 0 00-.5.5v3l-5.562 3.211V16a.499.499 0 00-.25-.433L1.5 12.211l5.562-3.21 2.604 1.503 1.005-.574-3.11-1.796a.998.998 0 00-1 0L.5 11.634a1 1 0 00-.5.866v7c0 .357.19.688.5.867l6.062 3.498c.31.18.691.18 1 0l6.062-3.498c.31-.18.5-.51.5-.867v-3a.5.5 0 00-.499-.5zm-7.063 6.711L1 19.5v-6.422l5.562 3.211v6.422z" />
      </g>
    </svg>
  )
}

export default SvgIconBlockchain
